<form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
  <h2 class="font-poppins text-[26px] font-medium leading-[32px] text-text-primary">
    {{ 'baa_signup_practice_details_title' | translate }}
  </h2>

  <div class="mb-7 mt-6 flex flex-col gap-3">
    <lib-input
      background="white"
      size="large"
      [label]="'baa_signup_practice_details_legal_name_label' | translate"
      formControlName="legalName"
      [hint]="isSubmitted() && form.controls['legalName'].invalid ? ('baa_signup_practice_details_legal_name_error' | translate) : ''"
      [state]="isSubmitted() && form.controls['legalName'].invalid ? 'error' : 'normal'"
    ></lib-input>

    <lib-input
      background="white"
      size="large"
      [label]="'baa_signup_practice_details_address_label' | translate"
      formControlName="address"
      [hint]="isSubmitted() && form.controls['address'].invalid ? ('baa_signup_practice_details_address_error' | translate) : ''"
      [state]="isSubmitted() && form.controls['address'].invalid ? 'error' : 'normal'"
    ></lib-input>

    <lib-input
      background="white"
      size="large"
      [label]="'baa_signup_practice_details_city_label' | translate"
      formControlName="city"
      [hint]="isSubmitted() && form.controls['city'].invalid ? ('baa_signup_practice_details_city_error' | translate) : ''"
      [state]="isSubmitted() && form.controls['city'].invalid ? 'error' : 'normal'"
    ></lib-input>

    <div class="flex w-full gap-3">
      <lib-dropdown-search
        class="w-1/2"
        size="large"
        formControlName="state"
        [label]="'baa_signup_practice_details_state_label' | translate"
        [options]="statesDropdownOptions"
        [hint]="isSubmitted() && form.controls['state'].invalid ? ('baa_signup_practice_details_state_error' | translate) : ''"
        [state]="isSubmitted() && form.controls['state'].invalid ? 'error' : 'normal'"
        [overlayMaxHeight]="'220px'"
        [overlayPositionStrategy]="[{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 0 }]"
      ></lib-dropdown-search>

      <lib-input
        background="white"
        class="!w-1/2"
        size="large"
        [label]="'baa_signup_practice_details_zip_label' | translate"
        formControlName="zip"
        [hint]="isSubmitted() && form.controls['zip'].invalid ? ('baa_signup_practice_details_zip_error' | translate) : ''"
        [state]="isSubmitted() && form.controls['zip'].invalid ? 'error' : 'normal'"
      ></lib-input>
    </div>

    <div class="flex flex-col items-center justify-center gap-2 rounded-3xl bg-background-light-grey py-5">
      <p class="typo-h5-book text-text-tertiary">{{ 'baa_signup_practice_details_signer_label' | translate }}</p>
      <p class="typo-h4-medium text-text-secondary">{{ form.controls['signerFullName'].value }}</p>
    </div>
  </div>

  <button type="submit" class="btn-primary w-full justify-center" [disabled]="service.isPracticeLoadingSignal()">
    {{ 'baa_signup_practice_details_cta' | translate }}
  </button>

  <p class="typo-h7-light text-center font-light text-text-tertiary">
    @for (part of agreementParts(); track $index) {
      @switch (part.token) {
        @case ('input1') {
          <ng-container [ngTemplateOutlet]="tos" />
        }
        @case ('input2') {
          <ng-container [ngTemplateOutlet]="privacy" />
        }
        @case ('input3') {
          <ng-container [ngTemplateOutlet]="baa" />
        }
        @default {
          {{ part.text }}
        }
      }
    }
  </p>
</form>

<ng-template #tos>
  <a [href]="termsOfServiceUrl" target="_blank" rel="noopener noreferrer" class="font-semibold text-primary-blue underline">
    {{ 'baa_signup_practice_details_agreement_tos' | translate }}
  </a>
</ng-template>
<ng-template #privacy>
  <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer" class="font-semibold text-primary-blue underline">
    {{ 'baa_signup_practice_details_agreement_privacy' | translate }}
  </a>
</ng-template>
<ng-template #baa>
  <a [href]="baaUrl" target="_blank" rel="noopener noreferrer" class="font-semibold text-primary-blue underline">
    {{ 'baa_signup_practice_details_agreement_baa' | translate }}
  </a>
</ng-template>
